"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var data;
        (function (data_1) {
            var map;
            (function (map) {
                class InitArgs {
                    constructor() {
                        this.dFilter = appn.emptyString;
                        this.showDataTable = false;
                        this.userLatLon = appn.emptyString;
                        this.userList = [];
                        this.dataMapEntries = appn.emptyString;
                    }
                }
                let _initArgs;
                let _map;
                let _entrieslayers = [];
                let _pageNum = 1;
                let _totalEntries = 0;
                let _resultsWithoutGPS = 0;
                let _searchValue = appn.emptyString;
                function init(args) {
                    _initArgs = args;
                    appn.dataView.init();
                    prependSearchAndFilters();
                    if (_initArgs.showDataTable)
                        setupViewParameters();
                    addEvents();
                    appn.popover.init();
                }
                map.init = init;
                appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function (channel, data) {
                    if (!_map)
                        return;
                    _map.invalidateSize();
                });
                function setupViewParameters() {
                    appn.dateFilter.init(_initArgs.dFilter);
                    const availableHeight = Number($('#content').height()) - Number($('#dataToolbar').height()) - Number($('#pagingToolbar').height()) - 30;
                    if (!isNaN(availableHeight))
                        $('#map').height(availableHeight);
                    _map = appn.ui.mapInit('map', 0, 0, 11, false);
                    const screenKey = $.getUrlVar('screenKey');
                    if (screenKey !== appn.emptyString)
                        getEntries(true);
                    $('#PageSize').change(function () {
                        getEntries(false);
                    });
                    $('#GoPrevious').click(function () {
                        if ($('#GoPrevious').hasClass('paginate_enabled_previous')) {
                            _pageNum--;
                            getEntries(false);
                        }
                    });
                    $('#GoNext').click(function () {
                        if ($('#GoNext').hasClass('paginate_enabled_next')) {
                            _pageNum++;
                            getEntries(false);
                        }
                    });
                }
                function getEntries(shouldUseEntryId) {
                    appn.dialog.showLoading();
                    const screenKey = $('#SelectedScreenKey').val();
                    const version = $('#SelectedVersionNo').val();
                    const pageSize = $('#PageSize').val();
                    const userId = $('#ByUser').val();
                    let entryId = null;
                    if (shouldUseEntryId === true)
                        entryId = $('#EntryId').val();
                    else
                        $('#EntryId').val(appn.emptyString);
                    const appnDateFilterValue = appn.dateFilter.getStateOrDefault();
                    const $form = $('form#appnForm');
                    if ($form.valid())
                        appn.ajax.post({
                            url: _initArgs.dataMapEntries,
                            dataType: 'json',
                            data: {
                                screenKey: screenKey,
                                version: version,
                                dfilter: appnDateFilterValue.type,
                                fromDate: appnDateFilterValue.fromDate,
                                toDate: appnDateFilterValue.toDate,
                                pageSize: pageSize,
                                pageNum: _pageNum - 1,
                                entryId: entryId,
                                searchId: encodeURIComponent(_searchValue),
                                userId: userId
                            },
                            done: function (data) {
                                processResult(data);
                            },
                            fail: function (jqXHR, textStatus, errorThrown) {
                                appn.toast.notify(appn.toast.Type.error, T('Failed to fetch map data.'));
                            }
                        });
                }
                function processResult(data) {
                    removeMarkers();
                    _resultsWithoutGPS = 0;
                    const userLatLon = _initArgs.userLatLon.split(',');
                    const userLat = userLatLon[0];
                    const userLon = userLatLon[1];
                    let lastEntryLatLng = new L.LatLng(userLat, userLon);
                    const markers = L.markerClusterGroup();
                    for (let i = 0; i < data.aaData.length; i++) {
                        const lat = data.aaData[i][3];
                        const lon = data.aaData[i][4];
                        if (lat !== 0 && lon !== 0) {
                            const entriesll = new L.LatLng(lat, lon, 0);
                            const entriesmark = new L.Marker(entriesll);
                            markers.addLayer(entriesmark);
                            const icon = L.divIcon({
                                html: '<div class="appn-mapPin"></div>' +
                                    '<div class="appn-mapShadow"></div>'
                            });
                            entriesmark.data = data.aaData[i];
                            entriesmark.data.splice(3, 2);
                            entriesmark.setIcon(icon);
                            entriesmark.on('click', markerClick);
                            lastEntryLatLng = entriesll;
                        }
                        else
                            _resultsWithoutGPS++;
                    }
                    _map.addLayer(markers);
                    _entrieslayers.push(markers);
                    updateUI(data);
                    _map.setView(lastEntryLatLng, 11);
                    const entryDiv = $('#entryData');
                    entryDiv.empty();
                    const columns = data.sColumns.split(',');
                    for (let i = 0; i < columns.length; i++)
                        entryDiv.append('<tr><td>' + columns[i] + '</td><td class="displayText"></td></tr>');
                    appn.saveMeState.init(function () {
                        getEntries(false);
                    }, function () {
                        getEntries(false);
                    }, '.map-filters');
                    appn.select.init();
                    if (data.aaData.length === 1)
                        markerClick(_entrieslayers[0]);
                    appn.dialog.hideLoading();
                    $('td').on('click', 'a#viewMedia', function (event) {
                        event.preventDefault();
                        appn.dialog.viewMediaFromElement($(this));
                    });
                }
                function updateUI(data) {
                    const pageSize = $('#PageSize').val();
                    _totalEntries = data.iTotalDisplayRecords;
                    let totalText = appn.strings.noResultsFound;
                    if (_totalEntries > 0) {
                        totalText = T('Showing {0} to {1} of {2} entries', (pageSize * _pageNum) - pageSize + 1, Math.min(pageSize * _pageNum, _totalEntries), _totalEntries);
                        if (_resultsWithoutGPS > 0)
                            totalText += '<br><i>(' + T('Cannot show {0} entries due to missing GPS location', _resultsWithoutGPS) + ')</i>';
                    }
                    $('#TotalsText').html(totalText);
                    if ((pageSize * _pageNum) < _totalEntries) {
                        $('#GoNext').removeClass('paginate_disabled_next');
                        $('#GoNext').addClass('paginate_enabled_next');
                    }
                    else {
                        $('#GoNext').removeClass('paginate_enabled_next');
                        $('#GoNext').addClass('paginate_disabled_next');
                    }
                    if (_pageNum > 1) {
                        $('#GoPrevious').removeClass('paginate_disabled_previous');
                        $('#GoPrevious').addClass('paginate_enabled_previous');
                    }
                    else {
                        $('#GoPrevious').removeClass('paginate_enabled_previous');
                        $('#GoPrevious').addClass('paginate_disabled_previous');
                    }
                }
                function markerClick(event) {
                    if (event !== undefined) {
                        const entryDivs = $('.displayText');
                        const data = (!event.target ? event.data : event.target.data);
                        if (data === undefined)
                            return;
                        for (let i = 1; i < data.length; i++)
                            $(entryDivs[i - 1]).html(data[i]);
                        appn.dialog.singleEntryExport.init();
                    }
                }
                function removeMarkers() {
                    for (let i = 0; i < _entrieslayers.length; i++)
                        _map.removeLayer(_entrieslayers[i]);
                    _entrieslayers = [];
                }
                function prependSearchAndFilters() {
                    const filtersContainer = $('.map-filters');
                    if (_initArgs.showDataTable) {
                        if (_initArgs.userList.length > 0)
                            $(appn.elementBuilder.buildAppnSelect(_initArgs.userList, 'ByUser', 'saveMeState select2-noinit')).appendTo(filtersContainer);
                        $(generateSeachInput()).appendTo(filtersContainer);
                    }
                    appn.sideFilterAndContent.appendShowButton(filtersContainer);
                    appn.saveMeState.init();
                    appn.select.init({ selector: '#ByUser', minimumResultsForSearch: '25' });
                }
                function addEvents() {
                    $('#SearchId').off().on('keydown', function (event) {
                        if (!(event.keyCode === 13) || !event.target || !(event.target.type === 'search'))
                            return;
                        event.preventDefault();
                        _searchValue = $('#SearchId').val();
                        $('#SearchId').blur();
                        _pageNum = 1;
                        getEntries(false);
                    });
                    $('#ByUser').off().on('change', function (event) {
                        event.preventDefault();
                        getEntries(false);
                    });
                }
                function generateSeachInput() {
                    return `<input placeholder="${T('Hit Enter to Search')}" type="search" class="form-control form-control-sm" id="SearchId" name="SearchId" aria-controls="DataTables_Table_0" title="${T('Filter results where the selected forms <b>Answers</b> start with a keyword typed in here.')}">`;
                }
            })(map = data_1.map || (data_1.map = {}));
        })(data = views.data || (views.data = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
